
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { ProductItem } from '@/models/Product';

@Component
export default class ItemsList extends Vue {
    @Prop()
    protected items!: ProductItem[]
    protected mutatedItems!: ProductItem[];

    constructor() {
        super();

        if (this.$attrs['data-items'] !== undefined && this.$attrs['data-items'] !== null)
        {
            this.mutatedItems = JSON.parse(this.$attrs['data-items']);
        }
        else {
            this.mutatedItems = this.items;
        }
    }

    protected isUsp(text: string): boolean {
        if (text && text.length >= 3 && text.substring(0, 3) == 'USP') {
            return true;
        }

        return false;
    }

    protected thousandSeparator(x: string) {
        if (x == null || x == undefined) {
            return null;
        }
        const pattern = /(-?\d+)(\d{3})/;
        while (pattern.test(x)) { x = x.replace(pattern, '$1 $2'); }
        return x;
    }
}
